import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

/**
 * Reusable layout for static content / legal pages.
 * Renders a clean, editorial two-column layout with a sticky sidebar and
 * long-form content on the right.
 */
export const ContentPage = ({ eyebrow, title, subtitle, sections, testId }) => (
  <div className="min-h-screen bg-[#F8F9FA]" data-testid={testId}>
    <Navbar />

    {/* Header */}
    <div className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
        <p className="text-[10px] uppercase tracking-widest text-[#2D7FF9] font-bold font-mono-num">
          — {eyebrow}
        </p>
        <h1 className="font-display font-extrabold text-4xl md:text-5xl mt-3 tracking-tight text-ink max-w-3xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-gray-600 mt-4 max-w-2xl text-[15px] leading-relaxed">
            {subtitle}
          </p>
        ) : null}
      </div>
    </div>

    {/* Body */}
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid lg:grid-cols-[240px_1fr] gap-12">
      <aside className="hidden lg:block lg:sticky lg:top-24 self-start">
        <p className="text-[10px] uppercase tracking-widest text-gray-500 font-bold mb-4">
          On this page
        </p>
        <ul className="space-y-2 text-sm">
          {sections.map((s, i) => (
            <li key={i}>
              <a
                href={`#${s.id}`}
                className="text-gray-600 hover:text-[#2D7FF9] transition-colors block py-1 border-l-2 border-gray-100 hover:border-[#2D7FF9] pl-3"
              >
                {s.heading}
              </a>
            </li>
          ))}
        </ul>
      </aside>

      <main className="max-w-3xl">
        <div className="space-y-12">
          {sections.map((s, i) => (
            <section key={i} id={s.id} className="scroll-mt-28">
              <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-ink">
                {s.heading}
              </h2>
              <div className="mt-4 space-y-4 text-gray-700 leading-relaxed text-[15px]">
                {s.body}
              </div>
            </section>
          ))}
        </div>
      </main>
    </div>

    <Footer />
  </div>
);
